export const SEVERAL = 'financing'
export const SINGLE = 'upfront'
export const QUOTA25 = 'quota25'
